import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import { InfoRow } from 'common/components/InfoRow';
import { Chip } from 'common/components/Chip';

interface IProps {
    score: number;
    scoreThreshold?: number | null;
}

export const ScoreInfoRow = ({ score, scoreThreshold }: IProps) => {
    const [translate] = useTranslation();

    return (
        <InfoRow description={translate('score')} descriptionSx={{ mt: '3px' }}>
            <Box sx={{ px: 1.25 }}>
                <Chip
                    color={score >= (scoreThreshold || 0) ? 'success' : 'error'}
                    label={`${Math.round(score * 100)}%`}
                />
            </Box>
        </InfoRow>
    );
};
